import { colors } from './colors';

export const shadows = {
  card: '0 1px 8px 0 rgb(0 0 0 / 0.05), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  layout: '0px 0px 24px 1px rgba(0, 0, 0, 0.08)',
  ['layout-dark']: '0px 0px 32px 1px rgba(0, 0, 0, 0.2)',
  outline: `0 0 0 4px ${colors.primary[50]}`,
};
